import React from "react";
import { EmptyState } from "@/components/common";
import { Inbox } from "lucide-react";

export function DataTable({ columns, rows, onRowClick, rowTestId, empty }) {
  if (!rows || rows.length === 0) {
    return empty || <EmptyState icon={Inbox} title="Nothing to show" />;
  }
  return (
    <div className="overflow-x-auto -mx-px">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 border-y border-slate-100 sticky top-0">
          <tr>
            {columns.map((c) => (
              <th key={c.key} className={`px-4 py-2.5 text-xs font-semibold text-slate-500 uppercase tracking-wider ${c.align === "right" ? "text-right" : "text-left"}`}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((row, i) => (
            <tr key={row.id || i} data-testid={rowTestId ? `${rowTestId}-${row.id || i}` : undefined}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              className={`${onRowClick ? "cursor-pointer" : ""} hover:bg-slate-50 ${i % 2 ? "bg-slate-50/40" : "bg-white"}`}>
              {columns.map((c) => (
                <td key={c.key} className={`px-4 py-2.5 ${c.align === "right" ? "text-right" : "text-left"} ${c.className || "text-slate-600"}`}>
                  {c.render ? c.render(row) : row[c.key] ?? "—"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const v = {
    primary: "bg-seq-green hover:bg-seq-greenhover text-white",
    secondary: "bg-white border border-slate-300 text-slate-700 hover:bg-slate-50",
    ghost: "text-slate-600 hover:bg-slate-100",
    danger: "bg-red-600 hover:bg-red-700 text-white",
    forest: "bg-seq-forest hover:bg-seq-foresthover text-white",
  }[variant];
  return (
    <button className={`inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium transition-colors disabled:opacity-50 ${v} ${className}`} {...props}>
      {children}
    </button>
  );
}

export function TextInput({ className = "", ...props }) {
  return <input className={`w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:border-seq-green focus:ring-2 focus:ring-seq-green/20 outline-none ${className}`} {...props} />;
}

export function Select({ className = "", children, ...props }) {
  return <select className={`w-full px-3 py-2 border border-slate-300 rounded-lg text-sm bg-white focus:border-seq-green focus:ring-2 focus:ring-seq-green/20 outline-none ${className}`} {...props}>{children}</select>;
}

export function Textarea({ className = "", ...props }) {
  return <textarea className={`w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:border-seq-green focus:ring-2 focus:ring-seq-green/20 outline-none ${className}`} {...props} />;
}
